import React from 'react';

interface BadgeProps {
  colour: string;
  displayText: string;
}
export default function Badge({
  colour,
  displayText
}: BadgeProps) {
  return (<span className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
    <svg className={`h-1.5 w-1.5`} fill={colour} viewBox="0 0 6 6" aria-hidden="true" role='img'>
      <circle cx={3} cy={3} r={3} />
    </svg>
    {displayText}
  </span>)
}
